<template>
  <div>
    <v-snackbar
      v-model="showNotice"
      :color="currentNotice.type === 'error' ? 'error' : 'success'"
      :timeout="currentNotice.timeout"
      bottom
      multi-line
      right
    >
      {{ currentNotice.message }}
      <template #action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showNotice = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentNotice: {},
      showNotice: false
    };
  },
  computed: {
    queue() {
      return this.$store.getters.getNotices;
    },
    hasNotices() {
      return this.queue.length > 0;
    }
  },
  watch: {
    queue(v) {
      const { currentNotice } = this;
      if (v.length == 0) {
        this.showNotice = false;
      }
      if (v.length > 0 && !Object.keys(currentNotice).length > 0) {
        this.useFirstNotice();
      }
    },
    showNotice(v) {
      if (!v) {
        setTimeout(() => {
          this.currentNotice = {};
          const { hasNotices } = this;
          if (hasNotices) {
            this.useFirstNotice();
          }
        }, 700);
      }
    }
  },
  mounted() {
    const { hasNotices } = this;
    if (hasNotices) {
      this.useFirstNotice();
    }
  },
  methods: {
    async useFirstNotice() {
      this.currentNotice = await this.$store.dispatch("shiftNotices");
      this.showNotice = true;
    }
  }
};
</script>
